import type { INicheCardListBase } from './niche-card-list.types'

export const useNicheCardListModel = ({
  niches,
  hasReachedSelectedNicheLimit,
  isNichePending,
  feature,
}: INicheCardListBase) => {
  const shouldDisplayAlert = hasReachedSelectedNicheLimit
  const shouldDisplayLoading = isNichePending && niches.length <= 7

  return { niches, shouldDisplayAlert, shouldDisplayLoading, feature }
}
